import { FirebaseOptions } from '@angular/fire/app';
import { InjectionToken } from '@angular/core';

export interface DamoAuthConfig {
  firebase: FirebaseOptions;
  fns: string;
  fnsOrigin: string;
  domain: string;
  postLoginRedirectUrl?: string;
}
export const damoAuthConfig = new InjectionToken<DamoAuthConfig>('DAMO_AUTH_CONFIG');
